import { PayloadAction } from '@reduxjs/toolkit';

import { hideLoader, showLoader } from '../root-slice';

// Совпадения в названиях экшена, при которых не будет отображаться лоадер
// Можно писать частичное совпадение, например, payments
// Временное решение
const actionsWithoutLoaderMatches = ['accruals/printAccrualReceipt'];

const checkWrongTypes = (actionType: string) =>
  !!actionsWithoutLoaderMatches.filter((name) => actionType.includes(name))
    .length;

export const loaderMiddleware = (store: any) => (next: any) => (
  action: PayloadAction
) => {
  const { type } = action;
  if (type.includes('/pending')) {
    store.dispatch(showLoader());
  } else if (type.includes('/fulfilled') || type.includes('/rejected')) {
    store.dispatch(hideLoader());
  }
  next(action);
};
